import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import outair_data from '../entities/outair_data'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface outair_dataState extends ListState<outair_data>{
    editoutair_data:outair_data
}
class UserMutations extends ListMutations<outair_data>{

}
class Outair_DataModule extends ListModule<outair_dataState,any,outair_data>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<outair_data>(),
        filterlist:new Array<outair_data>(),
        loading:false,
        editoutair_data:new outair_data()
    }
    actions={
        async getAll(context:ActionContext<outair_dataState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairData/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<outair_dataState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/OutairData/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<outair_dataState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairData/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_data>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async getPagedLast(context: ActionContext<outair_dataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/OutairData/GetPagedLast', { params: payload.data });
            let page = reponse.data.result as PageResult<outair_data>;
            return page.items;
        },
        async create(context:ActionContext<outair_dataState,any>,payload:any){
            await Ajax.post('/api/services/app/OutairData/Create',payload.data);
        },
        async uploadimg(context:ActionContext<outair_dataState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<outair_dataState,any>,payload:any){
            await Ajax.put('/api/services/app/OutairData/Update',payload.data);
        },
        async delete(context:ActionContext<outair_dataState,any>,payload:any){
            await Ajax.delete('/api/services/app/OutairData/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<outair_dataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/OutairData/GetById?Id='+payload.id);
            return reponse.data.result as outair_data;
        }
    };
    mutations={
        setCurrentPage(state:outair_dataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:outair_dataState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:outair_dataState,outair_data:outair_data){
            
            state.editoutair_data=outair_data;
            //console.log(state.editFloor);
        }
    }
}
const outair_dataModule=new Outair_DataModule();
export default outair_dataModule;